import { observable, computed, ObservableMap } from 'mobx';
import { TrackSchema } from '../../../types/schema';
import { CatalogueDataArray, PrismicSlice, SlicePageContext } from '../../../components/project-happy/utilities/types';

export class CreatorDashboardModel {
  @observable headerSlices: PrismicSlice[] = [];
  @observable defaultContentSlices: PrismicSlice[] = [];
  @observable includedContentSlices: PrismicSlice[] = [];

  @observable slices: PrismicSlice[] = [];

  @observable showIncludedContent = false;
  @observable loadingCarouselData = false;

  @observable carousels: ObservableMap<string, CatalogueDataArray>;
  @observable tracks: ObservableMap<string, TrackSchema>;

  @observable includedCarousels: ObservableMap<string, CatalogueDataArray>;
  @observable includedTracks: ObservableMap<string, TrackSchema>;

  @observable contentLoadError = false;

  @computed get sliceContext(): SlicePageContext {
    return {
      playlists: this.showIncludedContent ? this.includedCarousels : this.carousels,
      tracks: this.showIncludedContent ? this.includedTracks : this.tracks,
      carousels: { forceIndicatorPosition: 'centre' },
      externalDataLoading: this.loadingCarouselData,
    };
  }

  @computed
  get contentLoaded(): boolean {
    return this.defaultContentSlices.length > 0 && this.includedContentSlices.length > 0;
  }
}
